import { configureStore } from "@reduxjs/toolkit";
import reducers from "./reducers";
import { baseApi } from "../services/baseApi";

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(baseApi.middleware),
});
